export default __webpack_public_path__ + "static/media/category_switch_h.35070c0b.svg";